import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import Swal from 'sweetalert2';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { FirmaElectronicaService } from '../../services/firma-electronica/firma-electronica.service';
import { DatePipe } from '@angular/common';
import { environment } from 'environments/environment';

declare var $: any;
export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-listado-contrato-marco',
  templateUrl: './listado-contrato-marco.component.html',
  styleUrls: ['./listado-contrato-marco.component.scss']
})
export class ListadoContratoMarcoComponent implements OnInit {
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  loading:boolean;
  user: any;
  contratosM:any = [];
  id = '';
  formUpdateContratoMarco : FormGroup;
  rucProvFilter = new FormControl('');
  tipoCMFilter = new FormControl('');
  dataEnviarKeynua:any = {};
  id_Empresa : any;
  dataFiltro : FormGroup;
  dataEnviar : any = {};
  adjuntarPDF: boolean;

  filterValues = {
    Tipo_Servicio_Dsc: '',
    Proveedor:''
    };      
    dataSource =new MatTableDataSource( this.contratosM); 
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns: string[] = 
            ['checked','IDCMarco', 'Raz_Social','TipoCM','Pagare','Fecha_Inicio','Fecha_Final','Estado','Adjunto_PDF','Adjunto_PDF_Firmado'];

            
  constructor(private router :Router,private loginService:LoginService, private empresasService:EmpresasService,
    private firmaElectronicaService:FirmaElectronicaService,private datePipe: DatePipe,) { 
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.id_Empresa= this.user.id_empresa;
      this.dataFiltro = new FormGroup({
        "Fecha_Inicio": new FormControl(''),
        "Fecha_Fin": new FormControl(''),
        "Tipo":new FormControl('')
      });

    }

  ngOnInit() {
    this.ListadoContratoMvacio();    

    this.rucProvFilter.valueChanges
    .subscribe(
      Proveedor => {
        this.filterValues.Proveedor = Proveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.tipoCMFilter.valueChanges
      .subscribe(
        Tipo_Servicio_Dsc => {
          this.filterValues.Tipo_Servicio_Dsc = Tipo_Servicio_Dsc;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Tipo_Servicio_Dsc.toString().toLowerCase().indexOf(searchTerms.Tipo_Servicio_Dsc) !== -1
      && data.Razon_Social.toString().toLowerCase().indexOf(searchTerms.Proveedor) !== -1;
    }
  }
  
  listadoContratoM(){
    this.loading = true;
    this.dataEnviar.Tipo_Servicio =  this.dataFiltro.controls['Tipo'].value;
    if (this.dataFiltro.controls['Fecha_Inicio'].value == "") {
      this.dataEnviar.FechaInicio = "";
    }else{
      this.dataEnviar.FechaInicio =this.datePipe.transform(this.dataFiltro.controls['Fecha_Inicio'].value,'yyyy-MM-dd');
    }
    if (this.dataFiltro.controls['Fecha_Fin'].value == "") {
      this.dataEnviar.FechaFin = "";
    }else{
      this.dataEnviar.FechaFin =this.datePipe.transform(this.dataFiltro.controls['Fecha_Fin'].value,'yyyy-MM-dd');
    }
   
    this.empresasService.ListadoContratoM(this.dataEnviar.Tipo_Servicio,this.dataEnviar.FechaInicio, this.dataEnviar.FechaFin).subscribe(
      res=>{
        this.contratosM = res;
        console.log('this.contratosM',this.contratosM)
        this.dataSource = new MatTableDataSource(this.contratosM);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      }, err =>{
        Swal.fire({
        title:"!Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick : true,
          heightAuto: false
        });
       this.loading = false;  
      }    
    )

  }
  cerrarPopUpFirmado(){
    this.adjuntarPDF = false;
   }

  ListadoContratoMvacio(){
    this.loading = true;
    this.empresasService.ListadoContratoMvacio(this.id_Empresa).subscribe(
      resp=>{
        this.contratosM = resp;
        console.log('this.contratosMM',this.contratosM)
        this.dataSource = new MatTableDataSource(this.contratosM);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      }, error =>{
        Swal.fire({
        title:"!Algo salió mal!",
          text: error.error['error'],
          type: "warning",
          allowOutsideClick : true,
          heightAuto: false
        });
       this.loading = false;  
      }    
    )
  }

  bajaContratoMarco(idContratoMarco){
    
    Swal.fire({
      title: "Baja de contrato marco",
      text: "¿desea dar de baja el contrato Marco Nro. "+idContratoMarco+"?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if(result.value){
        this.loading = true;
        this.formUpdateContratoMarco = new FormGroup({
          "Estado":new FormControl('B',  Validators.required),
          "Baja_Usuario":new FormControl(this.user.Usuario,  Validators.required),
          "IDCMarco":new FormControl(idContratoMarco)
        });
        this.empresasService.bajaContratoMarco(this.formUpdateContratoMarco.getRawValue())
          .subscribe(res => {
            this.ListadoContratoMvacio();
        })        
      }
    });    

  }

  altaContratoMarco(element:any){
    this.adjuntarPDF = true;
    this.empresasService.dataContratoM = element;  
  }

  enviarContratoKeynua(IDCMarco :any){
    Swal.fire({
      title: 'Enviar contrato marco a Keynua',
      text: '¿Desea enviar contrato digital a keynua.?',
      type: "info",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.dataEnviarKeynua.IDCMarco = IDCMarco;
        this.enviarContratoMarcoElectronico(this.dataEnviarKeynua);
      }else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    });
  }

  enviarContratoMarcoElectronico(dataEnviarKeynua){
  
   Swal.fire({
    title: 'Espere',
    text: 'Enviando contrato marco a keynua.',
    type: 'info',
    heightAuto: false
   });
  Swal.showLoading();
   this.firmaElectronicaService.enviarContratoMarcoElectronico(dataEnviarKeynua).subscribe(
       res => {  
        Swal.close();     
         this.showNotification('success','top','right','Documento enviado satisfactoriamente para su firma digital.');
       },err => {
         if (err.error.message) {
          this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + err.error.message);
         }else{
          let error = "";
          error = err.error.error;
          this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + error);
         }
       
       }
   );
 }

  Pagare(element:any) {
    this.loginService.clickGuard = true;       
    this.router.navigate(['/empresas/contratoMarco/pagare'])
    this.empresasService.pagareContrato = element; 
    this.empresasService.pagareDatos = element;  
  }

  showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
